// this file contains functions to help in validation of cms data
// @TODO tests for this file! 👾 👾 👾 💥 👾

import {
  homePageRequiredFields,
  circularExamplePageRequiredFields,
  standardPageRequiredFields,
  structurePageRequiredFields,
  subPageRequiredFields,
  webflowPageRequiredFields,
} from '../config/content-type-required-fields';

export const validatePageData = (pageData, pageTypeLabel, requiredFields) => {
  const missingRequiredFields = requiredFields.filter(
    requiredFieldName => pageData[requiredFieldName] === null
  );

  const validationDetails = {
    isValid: true,
    errors: [],
  };

  if (missingRequiredFields.length > 0) {
    validationDetails.isValid = false;
    validationDetails.errors = [
      {
        contentful_id: pageData.contentful_id,
        pageTypeLabel,
        missingRequiredFields,
      },
    ];
  }

  return validationDetails;
};

export const validateHomePageData = pageData => {
  return validatePageData(pageData, 'Home Page', homePageRequiredFields);
};

export const validateCircularExamplePageData = pageData => {
  return validatePageData(
    pageData,
    'Circular Example Page',
    circularExamplePageRequiredFields
  );
};

export const validateStandardPageData = pageData => {
  return validatePageData(
    pageData,
    'Standard Page',
    standardPageRequiredFields
  );
};

export const validateWebflowPageData = pageData => {
  return validatePageData(pageData, 'Webflow Page', webflowPageRequiredFields);
};

export const validateStructurePageData = (structurePageData, subPageData) => {
  const structurePageValidationDetails = validatePageData(
    structurePageData,
    'Structure Page',
    structurePageRequiredFields
  );

  const subPageValidationDetails = validatePageData(
    subPageData,
    'Sub Page',
    subPageRequiredFields
  );

  const validationDetails = {
    isValid:
      structurePageValidationDetails.isValid &&
      subPageValidationDetails.isValid,
    errors: structurePageValidationDetails.errors.concat(
      subPageValidationDetails.errors
    ),
  };

  return validationDetails;
};
